import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { QrCodeService } from "./qr-code.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LayoutPrintService } from "../layout-print/layout-print.service";
import { Router } from "@angular/router";

declare var $;


@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.css'],
  providers: [
    QrCodeService,
    LayoutPrintService
  ]
})
export class QrCodeComponent implements OnInit {


  title: string;
  elementType: 'url' | 'canvas' | 'img' = 'url';

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  qrCodeList: any;
  qrCode: any = {};
  totalElements: number;
  modal: any = {};
  listPrint: Array<any>;
  checkedAll: boolean = true;
  layoutPrintList: any=[];
  selectedLayout: string;
  sizeQrcode: any;
  //watch variable change
  differ: any;
  constructor(
    private qrCodeService: QrCodeService,
    private layoutPrintService: LayoutPrintService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "QR Code";
    this.filterParams = {
      size: 5,
      page: 0
    };
    this.getLayoutPrintList();
 
    this.listPrint = new Array<any>();
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getQrCodeList();
    }
  }

  getLayoutPrintList() {
    this.isLoading = true;
    this.layoutPrintService.getLayoutPrintList({page:0, size: 20})
      .then(res => {
        if( res.status === 1 )
        {
          this.layoutPrintList = res.data.dataList;
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
  }

  getQrCodeList() {
      this.checkedAll = false;
    this.isLoading = true;
    this.qrCodeService.getQrCodeList(this.filterParams)
      .then(res => {
        if (res.status === 1) {
          this.qrCodeList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  initModal(state, category: any = {}) {

    switch (state) {
      case 'create': {
        this.modal = {
          title: 'Generate Qr Code',
          btnName: 'Create',
          state: state
        };
        this.qrCode.productId = '';
        this.qrCode.numberCode = '';
      }
        break;
      // case 'edit': {
      //   this.modal = {
      //     title: 'Edit product',
      //     btnName: 'Save',
      //     state: state
      //   };
      //   this.editCategory ={
      //     id: category._id,
      //     type: category.type,
      //     name: category.name,
      //     status: category.status
      //   };
      // }
      //   break;
    }
    $('#myModal').modal('show');
  }

  onSubmit(formQrCode) {
    localStorage.removeItem('printData');
    switch (this.modal.state) {
      case 'create': {
        this.qrCodeService.generateQrCode(formQrCode.value)
          .then(res => {
            if (res.status === 1) {
              this.getQrCodeList();
              localStorage.setItem('printData', JSON.stringify(res.data));
              this.toastr.success('Generate ' + formQrCode.value.numberPerCode + ' QrCode.', 'Success!');
              $('#myModal').modal('hide');
            } else  {
              this.toastr.error(res.message, 'Error!');
              if (res.errorCode === 3000) {
                localStorage.setItem("alert", JSON.stringify(res.message));
                this.router.navigate(['login']);
              }
            }
          })
          .catch(err => console.log(err));
      }
        break;
    }
    $('#selectLayout').modal('show');
  }

  printQrCode(qrCode) {
    let printData: any = new Array();
    printData.push(qrCode);
    localStorage.setItem('printData', JSON.stringify(printData)); 
    $('#selectLayout').modal('show');
  }

  openWindowPrint() {
    var left = (screen.width / 2) - (600 / 2);
    var top = (screen.height / 2) - (600 / 2);
    let path = 'print-qrcode';
    if (this.sizeQrcode === 'small') {
      path = 'print-qrcode-small';
    }
    window.open('#/'+ path +'/'+ this.selectedLayout, '_blank',
      'width=600,height=600, top=' + top + ', left=' + left + ',scrollbars=no,menubar=no,toolbar=no,'
      + 'location=no,status=no,titlebar=no');
  }

  printAll(){
    localStorage.setItem('printData', JSON.stringify(this.listPrint)); 
    $('#selectLayout').modal('show');
    let listId = [];
    this.listPrint = [];
    this.checkedAll =false;
  }

  deleteQrCode(listId: any = []) {
    if (listId.length == 0 ){
      this.listPrint.forEach(item => {
        listId.push(item.serialId);
      });
    }
    if (confirm("Confirm delete?")) {
      this.qrCodeService.deleteQrCode(listId)
      .then(res => {
        if (res.status === 1) {
          this.getQrCodeList();
          this.toastr.success('Deleted', 'Success!');
          this.listPrint = [];
          this.checkedAll =false;
        }  else  {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
      })
      .catch(err => console.log(err));
    }
  }

  setQrCodeUsed(listId: any, ckb: any){
    this.qrCodeService.setUsedQrCode(listId, ckb.checked)
    .then(res => {
      if (res.status === 1) {
        this.toastr.success('Setted!', 'Success!');
      }  else  {
        this.toastr.error(res.message, 'Error!');
        if (res.errorCode === 3000) {
          localStorage.setItem("alert", JSON.stringify(res.message));
          this.router.navigate(['login']);
        }
      }
    })
    .catch(err => console.log(err));
  }

  checkChange(qrcode: any, ckb: any) {
    let index = this.listPrint.findIndex(i => i.serialId == qrcode.serialId);
    if (ckb.checked == true && index == -1) {
      this.listPrint.push(qrcode);
    }
    else  {
      this.listPrint.splice(index, 1);
    }
  }

  checkAll(ckbAll: any){
    this.checkedAll = ckbAll.checked;
      this.qrCodeList.forEach(item => {
        this.checkChange(item, ckbAll);
      });
  }

  isChecked(serialId: string) {
    let index = this.listPrint.findIndex(i => i.serialId == serialId);
    if (index == -1) 
      return false;
    return true;
  }
}



// WEBPACK FOOTER //
// /build/client-cms/src/app/qr-code/qr-code.component.ts